import { Button, CarouselNewArrow, CarouselNew } from 'components'
import { getSvaData } from 'utils'
import { DRAWER_KEY, FIREBASE_EVENTS, TV_PLAN_STATUS_TAG_LABEL } from 'app-constants'
import { useDispatch, useSelector } from 'react-redux'
import { useFirebaseEvent } from 'hooks'
import { setData, setDrawer } from 'slices/drawer'
import { TV_PLAN_STATUS_CLASSNAME } from './constants'
import './style.scss'

export function DigitalServiceCarousel({ contract }) {
  const { contractAdditionals = [] } = contract || {}
  const { isEligibleToBuy } = useSelector(({ store }) => store)
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  function handleClick(additional) {
    dispatch(setDrawer(DRAWER_KEY.DETAILS_SVA))
    dispatch(setData({ additional }))
  }

  function handleClickButton() {
    sendEvent(FIREBASE_EVENTS.SOFTBUNDLE_CARD_ACCESS_STORE)
    dispatch(setDrawer(DRAWER_KEY.STORE))
  }

  function getCarouselConfig() {
    const svaLength = contractAdditionals.length
    return {
      align: 'start',
      gap: '0',
      customArrowComponent: renderCustomArrow,
      slidesToScroll: 1,
      containScroll: false,
      variableWidth: svaLength < 4,
      itemsPerView: svaLength > 4 ? 4 : svaLength,
      breakpoints: {
        '(min-width: 600px)': {
          loop: svaLength > 4,
          containScroll: true,
        },
      },
    }
  }

  function renderDigitalServiceCard(additional) {
    const { image, itemCode, itemName, status } = getSvaData(additional)
    return (
      <button
        key={itemCode}
        onClick={() => handleClick(additional)}
        className='digital-service-card-container'
        type='button'
      >
        <div className='card'>
          <div className='info'>
            <img src={image} alt={itemName} className='logo' />
            <span className='name'>{itemName}</span>
          </div>
          <div className={`tag ${TV_PLAN_STATUS_CLASSNAME[status] || ''}`}>
            {TV_PLAN_STATUS_TAG_LABEL[status] || ''}
          </div>
        </div>
      </button>
    )
  }

  function renderCustomArrow(props) {
    const { className, isNext } = props

    if (!isNext) return null

    return <CarouselNewArrow {...props} className={`${className} digital-service-carousel-arrow`} />
  }

  if (!contractAdditionals.length) return null

  function renderStoreButton() {
    if (!isEligibleToBuy) return null

    return (
      <Button className='button' onClick={handleClickButton}>
        Adicionar mais serviços
      </Button>
    )
  }

  return (
    <div className='digital-service-carousel'>
      <div className='digital-service-info'>
        <h2 className='title'>Meus serviços digitais</h2>
        <p className='description'>Acesse os serviços que estão disponíveis no seu plano</p>
      </div>
      <div className='digital-service-carousel-container'>
        <CarouselNew {...getCarouselConfig()}>
          {contractAdditionals.map(renderDigitalServiceCard)}
        </CarouselNew>
      </div>

      {renderStoreButton()}
    </div>
  )
}
